import React from 'react';
import { connect } from 'react-redux';
import { fetchPublicBlogPosts } from '../../modules/blog/actions';
import Carousel from '../../components/Carousel';

class FooterContainer extends React.Component {
  componentWillMount() {
    if (Object.keys(this.props.posts).length < 1) {
      this.props.fetchPublicBlogPosts();
    }
  }
  render() {
    return (
      <Carousel data={this.props.posts} loading={this.props.loading} language={this.props.language} />
    )
  }
}

function mapStateToProps(state) {
  return {
    posts: state.blogPosts.publicPosts,
    loading: state.blogPosts.loading,
    language: state.preference.language,
  }
}

const mapActionsToProps = {
  fetchPublicBlogPosts,
}

export default connect(mapStateToProps, mapActionsToProps)(FooterContainer);


// WEBPACK FOOTER //
// ./src/pages/Home/carouselContainer.js